import { I18n } from '@calendly/i18n';
import { SimplePopup } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeRolePopupMembershipsSelector } from './selectors';
import { closeChangeRolePopup, changeOwnership } from './slice';
const preambleCss = "pqso3vx";
const Preamble = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(preambleCss, props.className)} />;
});
const listCss = "l5l9xqo";
const List = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ol';
  return <Component ref={ref} {...restProps} className={classNames(listCss, props.className)} />;
});
const warningCss = "w18nw3r5";
const Warning = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(warningCss, props.className)} />;
});
export const OwnershipWarningPopup = () => {
  const dispatch = useDispatch();
  const onClose = () => dispatch(closeChangeRolePopup());
  const [submitting, setSubmitting] = useState(false);
  const onConfirm = async () => {
    setSubmitting(true);
    await dispatch(changeOwnership());
    setSubmitting(false);
  };
  const {
    name
  } = useSelector(changeRolePopupMembershipsSelector)[0];
  return <SimplePopup onClose={onClose} onConfirm={onConfirm} title={I18n.t('publisher.organization.change_owner.heading')} cancelLabel={I18n.t('publisher.action.cancel')} isLoading={submitting} confirmLabel={I18n.t('publisher.action.apply')}>
      <Preamble>{I18n.t('publisher.organization.change_owner.preamble', {
        name
      })}</Preamble>
      <List>
        <li>{I18n.t('publisher.organization.change_owner.no_longer_owner')}</li>
        <li>{I18n.t('publisher.organization.change_owner.stay_admin')}</li>
        <li>{I18n.t('publisher.organization.change_owner.will_now_manage', {
          name
        })}</li>
        <li>{I18n.t('publisher.organization.change_owner.accept_payments', {
          name
        })}</li>
      </List>
      <Warning>{I18n.t('publisher.organization.change_owner.cannot_undo')}</Warning>
    </SimplePopup>;
};

require("./ownership_warning_popup.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ownership_warning_popup.js");